export const isProduction = process.env.NODE_ENV === 'production';

export const isDev = process.env.NODE_ENV === 'development';

export const isTest = process.env.NODE_ENV  === 'test';

export const isInBrowser = typeof window !== 'undefined';

export const isKwai = isInBrowser && (navigator?.userAgent?.includes('Kwai'));

